export enum BADGE_VARIANTS {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  NEUTRAL = 'neutral',
  TERTIARY = 'tertiary',
}

export enum BADGE_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
}
